const priceContracts: {cakeAddress: string, busdAddress: string, lpAddress:string} = {
  cakeAddress: '0xD23811058Eb6e7967D9a00dc3886E75610c4AbBa',
  busdAddress: '0xe9e7cea3dedca5984780bafc599bd69add087d56',
  lpAddress: '0xA12e1e2E2dea79694448aB9ef63bd4D82a26d90c'
}

export default priceContracts